/** @format */

import React, { Component } from 'react';
import { Segment, Header, Table, Icon } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';

@inject('ClientsStore')
@observer
class ClientContacts extends Component {
  renderContent = content => {
    if (content !== null && content !== undefined && content !== '') {
      return content;
    } else {
      return '-';
    }
  };

  render() {
    const { ClientsStore } = this.props;
    const currentClient = ClientsStore.currentClient;
    return (
      <Segment className="reqPart-box headed-segment" padded>
        <div className="segment-header smaller">
          <Header as="h4">
            <small>
              <Icon name="envelope" />
            </small>
            Contatti
          </Header>
        </div>
        <Table compact basic="very" fixed celled>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <small>
                  <strong>
                    <Icon name="phone" /> Telefono
                  </strong>
                </small>
                <br />
                {this.renderContent(currentClient.data.landPhone)}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>
                    <Icon name="mobile" /> Cellulare
                  </strong>
                </small>
                <br />
                {this.renderContent(currentClient.data.mobPhone)}
              </Table.Cell>
              <Table.Cell>
                <small>
                  <strong>
                    <Icon name="mail" /> email
                  </strong>
                </small>
                <br />
                {this.renderContent(currentClient.data.email)}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}

export default ClientContacts;
